<div class="flex bg-transparent">
    <div
        class="w-[120px] rounded-l-lg flex justify-center items-center border-l border-t border-b"
        [class.border-green-600]="success"
        [class.border-amber-500]="warning"
        [class.border-red-600]="error"
        [class.border-blue-600]="info"
        [class.bg-green-500]="success"
        [class.bg-amber-500]="warning"
        [class.bg-red-600]="error"
        [class.bg-blue-500]="info"
    >
        <div class="self-center relative">
            <mat-icon class="mat-icon-alert absolute top-[-11px] left-[-13px]" color="white">
                {{ icon }}
            </mat-icon>
        </div>
    </div>
    <div
        class="text-black items-center border-r border-t border-b rounded-r-lg"
        [class.w-auto]="width == 'auto'"
        [class.w-full]="width == 'full'"
        [class.bg-green-50]="success"
        [class.bg-amber-50]="warning"
        [class.bg-red-50]="error"
        [class.bg-blue-50]="info"
        [class.border-green-600]="success"
        [class.border-amber-500]="warning"
        [class.border-red-600]="error"
        [class.border-blue-600]="info"
    >
        <div class="p-4">
            <h1 *ngIf="title" class="text-lg font-bold">
                {{ title }}
            </h1>
            <hr
                *ngIf="title"
                class="separator mb-2"
                [class.border-green-600]="success"
                [class.border-amber-500]="warning"
                [class.border-red-600]="error"
                [class.border-blue-600]="info"
            />
            <ng-content></ng-content>
        </div>
        <hr
            class="separator mb-0 max-w-full h-1-px"
            [class.border-green-600]="success"
            [class.border-amber-500]="warning"
            [class.border-red-600]="error"
            [class.border-blue-600]="info"
            [class.hidden]="ngcFooter.childNodes.length == 0"
        />
        <div
            #ngcFooter
            class="text-right p-2 bg-white"
            [class.hidden]="ngcFooter.childNodes.length == 0"
        >
            <ng-content select="[app-alert-footer]"></ng-content>
        </div>
    </div>
</div>
